// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { RelatedEntity } from "./RelatedEntity";
import {
  RelatedEntityFromJSON,
  RelatedEntityFromJSONTyped,
  RelatedEntityToJSON,
  RelatedEntityToJSONTyped,
} from "./RelatedEntity";

/**
 *
 * @export
 * @interface ApiKeyCreateV2
 */
export interface ApiKeyCreateV2 {
  /**
   *
   */
  name: string;
  /**
   *
   */
  expiresAt?: Date | null;
  /**
   *
   */
  relatedTo: RelatedEntity;
}

/**
 * Check if a given object implements the ApiKeyCreateV2 interface.
 */
export function instanceOfApiKeyCreateV2(value: object): value is ApiKeyCreateV2 {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (
    (!("relatedTo" in (value as Record<string, any>)) &&
      !("related_to" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["relatedTo"] === undefined &&
      (value as Record<string, any>)["related_to"] === undefined)
  )
    return false;
  return true;
}

export function ApiKeyCreateV2FromJSON(json: any): ApiKeyCreateV2 {
  return ApiKeyCreateV2FromJSONTyped(json, false);
}

export function ApiKeyCreateV2FromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiKeyCreateV2 {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    expiresAt:
      json["expires_at"] === undefined
        ? undefined
        : json["expires_at"] === null
        ? null
        : parseDateTime(json["expires_at"]),
    relatedTo: RelatedEntityFromJSON(json["related_to"]),
  };
}

export function ApiKeyCreateV2ToJSON(json: any): ApiKeyCreateV2 {
  return ApiKeyCreateV2ToJSONTyped(json, false);
}

export function ApiKeyCreateV2ToJSONTyped(
  value?: ApiKeyCreateV2 | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    expires_at:
      value["expiresAt"] == null ? value["expiresAt"] : serializeDateTime(value["expiresAt"]),
    related_to: RelatedEntityToJSON(value["relatedTo"]),
  };
}
